import { Box, Button } from '@nimbus-ds/components';
import { EmptyMessage } from '@nimbus-ds/patterns';
import { useTranslationCommon } from 'commons/hooks';
import ErrorImage from './error.png';

function ErrorScreen() {
  const t = useTranslationCommon('errorPage');
  const onReload = () => {
    // Redirects to '/' if its mobile or '/admin/v2/' if its web because at '/' storefront is rendered
    if (window.location.origin.includes('localhost')) {
      window.location.href = '/';
    } else {
      window.location.href = '/admin/v2/';
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flex="1"
      height="100vh"
      padding="4"
    >
      <EmptyMessage
        title={t('title')}
        text={t('text')}
        actions={
          <Button appearance="primary" onClick={onReload}>
            {t('action')}
          </Button>
        }
        illustration={
          <img
            width="90%"
            alt="stratus-app-crash-img"
            src={ErrorImage}
            style={{ maxWidth: 480 }}
          />
        }
      />
    </Box>
  );
}

export default ErrorScreen;
